import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Typography, Paper, Grid } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import './AdminDashboard.scss'; // SCSS file for styles

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const userRole = localStorage.getItem('userRole');
    if (userRole !== 'ADMIN') {
      navigate('/');
    } else {
      setIsAdmin(true);
    }
  }, [navigate]);

  if (!isAdmin) {
    return null; // Prevents flashing UI
  }

  return (
    <Container className="admin-dashboard">
      <Paper className="dashboard-container" elevation={3}>
        <Typography variant="h4" className="dashboard-title">
          Admin Panel
        </Typography>
        <Grid container spacing={3} className="dashboard-grid">
          <Grid item xs={12} md={4}>
            <Link to="/admin/manage-blogs" className="dashboard-link">
              <Paper className="dashboard-card" elevation={3}>
                <PostAddIcon className="dashboard-icon" />
                <Typography variant="h6">Manage Blogs</Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid item xs={12} md={4}>
            <Link to="/admin/manage-users" className="dashboard-link">
              <Paper className="dashboard-card" elevation={3}>
                <PeopleIcon className="dashboard-icon" />
                <Typography variant="h6">Manage Users</Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid item xs={12} md={4}>
            <Link to="/" className="dashboard-link">
              <Paper className="dashboard-card logout-card" elevation={3}>
                <ExitToAppIcon className="dashboard-icon" />
                <Typography variant="h6">Logout</Typography>
              </Paper>
            </Link>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default AdminDashboard;
